module.exports = __webpack_public_path__ + "media/rotate.20296fb8.mp3";